import { render } from "./TradeChart.vue?vue&type=template&id=6fef27fa&ts=true"
import script from "./TradeChart.vue?vue&type=script&lang=ts"
export * from "./TradeChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\projects\\wintick\\wintick-applets-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__